// src/utils/toastService.js
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const showToast = (
    title,
    message,
    onClickHandler,
    type = "info",
    position = "bottom-right"
) => {
    toast(
        <div
            onClick={() => {
                if (typeof onClickHandler === "function") {
                    onClickHandler();
                }
            }}
            style={{ cursor: onClickHandler ? "pointer" : "default" }}
        >
            <strong>{title}</strong>
            <p style={{ margin: 0 }}>{message}</p>
        </div>,
        {
            type,
            position,
            autoClose: 15000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
        }
    );
};
